import React, { useMemo } from 'react';

import { VariablePanel } from 'src/components';
import { useDocumentParams } from 'src/helpers';
import { useGetVariablesForDocument } from 'src/hooks';

export function DocumentVariables(): JSX.Element {
  const { documentId } = useDocumentParams();
  const { loading, variables } = useGetVariablesForDocument(documentId, {
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-first',
  });
  const panelVariables = useMemo(() => {
    return variables.filter(v => {
      return Boolean(!v.deletedAt);
    });
  }, [variables]);

  return <VariablePanel documentId={documentId} loading={loading} variables={panelVariables} />;
}
